import type {AppStorage} from '../index'
import type {AuthTokensResponse, Incoming, SocialIncoming} from '../models/auth'
import {
  SupportProblemType,
  VerifyMode,
  convertIncomingToRequestParams,
  convertVerifyModeToRequestParam,
} from '../models/auth'
import type {MakeRequest, RestResponse} from './request'

export class AuthApi {
  constructor(private request: MakeRequest, private storage: AppStorage) {}

  authSocial = (
    incoming: SocialIncoming,
  ): Promise<RestResponse<AuthTokensResponse>> => {
    return this.request.newRequest<AuthTokensResponse>({
      endpoint: 'v2/auth/token/social',
      body: {
        type: incoming.type,
        token: incoming.token,
      },
    })
  }

  authEmail = (
    email: string,
    password: string,
  ): Promise<RestResponse<AuthTokensResponse>> => {
    return this.request.newRequest<AuthTokensResponse>({
      endpoint: 'v2/auth/token/email',
      body: {
        data: {email, password},
      },
    })
  }

  sendCode = (
    incoming: Incoming,
    verifyMode: VerifyMode,
  ): Promise<RestResponse<undefined>> => {
    const type = convertVerifyModeToRequestParam(verifyMode)
    return this.request.newRequest<undefined>({
      endpoint: 'v2/auth/code',
      body: {
        data: {
          ...convertIncomingToRequestParams(incoming),
          type,
        },
      },
    })
  }

  checkCode = (
    incoming: Incoming,
    verifyMode: VerifyMode,
    code: string,
  ): Promise<RestResponse<AuthTokensResponse>> => {
    const type = convertVerifyModeToRequestParam(verifyMode)
    return this.request.newRequest<AuthTokensResponse>({
      endpoint: 'v2/auth/token/code',
      body: {
        data: {
          ...convertIncomingToRequestParams(incoming),
          type,
          code,
        },
      },
    })
  }

  contactSupport = (
    message: string,
    problemType: SupportProblemType,
  ): Promise<RestResponse<undefined>> => {
    // const serializedMessage = JSON.stringify({
    //   message,
    //   app_id: this.storage.platform,
    //   type: problemType,
    // })
    return this.request.newRequest<undefined>(
      {
        endpoint: 'v2/support/contact',
        body: {
          message,
          app_id: this.storage.platform,
          type: problemType,
        },
      },
      // dataResponseConverter,
    )
  }

  remindPassword = async (email: string): Promise<RestResponse<undefined>> => {
    return this.request.newRequest({
      endpoint: 'v2/auth/reset-password',
      body: {email},
    })
  }

  resetPassword = async (email: string): Promise<RestResponse<undefined>> => {
    return this.request.newRequest({
      endpoint: 'v2/auth/reset-password',
      body: {email},
    })
  }

  resetPasswordConfirm = async (
    password: string,
    token: string,
  ): Promise<RestResponse<undefined>> => {
    return this.request.newRequest({
      endpoint: 'v2/auth/reset-password/confirm',
      body: {password, token},
    })
  }

  logout = (deviceId: string): Promise<RestResponse<undefined>> => {
    return this.request.newRequest<undefined>({
      endpoint: 'v2/auth/logout',
      body: {deviceId},
      allowEmptyResponse: true,
    })
  }
}
